export const DRIVER_OPERATIONAL_STATUS = {
  UNASSIGNED: "unassigned",
  ON_TRIP: "onTrip",
  SUSPENDED: "suspended",
  STANDBY: "standby"
};

export const DRIVER_OPERATIONAL_STATUS_COLOR = {
  [DRIVER_OPERATIONAL_STATUS.UNASSIGNED]: "blue",
  [DRIVER_OPERATIONAL_STATUS.ON_TRIP]: "purple",
  [DRIVER_OPERATIONAL_STATUS.SUSPENDED]: "red",
  [DRIVER_OPERATIONAL_STATUS.STANDBY]: "gray",
};

export const DRIVER_OPERATIONAL_STATUS_LABEL = {
  [DRIVER_OPERATIONAL_STATUS.UNASSIGNED]: "Unassigned",
  [DRIVER_OPERATIONAL_STATUS.ON_TRIP]: "On Trip",
  [DRIVER_OPERATIONAL_STATUS.SUSPENDED]: "Suspended",
  [DRIVER_OPERATIONAL_STATUS.STANDBY]: "Standby",
};

export const DRIVER_OPERATIONAL_STATUS_OPTIONS = [
  DRIVER_OPERATIONAL_STATUS.UNASSIGNED,
  DRIVER_OPERATIONAL_STATUS.ON_TRIP,
  DRIVER_OPERATIONAL_STATUS.SUSPENDED,
  DRIVER_OPERATIONAL_STATUS.STANDBY,
];

export const DRIVER_OPERATIONAL_STATUS_DISPATCH_LABEL = {
  [DRIVER_OPERATIONAL_STATUS.UNASSIGNED]: "Available",
  [DRIVER_OPERATIONAL_STATUS.ON_TRIP]: "Busy",
  [DRIVER_OPERATIONAL_STATUS.SUSPENDED]: "Suspended",
  [DRIVER_OPERATIONAL_STATUS.STANDBY]: "Available",
};
